import { render, staticRenderFns } from "./GeneralLogin.vue?vue&type=template&id=a4978d44&"
import script from "./GeneralLogin.vue?vue&type=script&lang=js&"
export * from "./GeneralLogin.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLogin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports